'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ImgixConstants = {
    'IMG_SERVICE_URL': 'https://cba.imgix.net',
    'DEFAULT_PARAMS': {
        'fit': 'crop'
    }
};

exports.default = ImgixConstants;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/image/imgix.constants.js
// module id = 809
// module chunks = 0